import React, { useState } from "react";
import { Link } from "react-router-dom";

import {
  Book,
  BroadcastPin,
  CurrencyPound,
  DoorClosed,
  People,
  Speedometer2,
  GraphUp,
  GlobeEuropeAfrica,
  BarChart,
} from "react-bootstrap-icons";

import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import Offcanvas from "react-bootstrap/Offcanvas";

import Dropdown from "./dropdown";
import Logo from "../logo/BI logo 250.png";
import {
  platformGetToken,
  platformGetDecodedToken,
} from "./helpers/localStorageHelper";
import { onLogout } from "./helpers/utils";

const NavBarMenu = (data) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };
  const handleClose = () => {
    setMenuOpen(false);
  };

  const [value] = useState(30);
  const [instance] = useState();

  return (
    <Navbar
      id="navbar-main"
      key="xxl"
      expand={false}
      sticky="top"
      className="mb-4"
      bg="dark"
      data-bs-theme="dark"
    >
      <Container fluid>
        <Navbar.Brand href="/home">
          <img src={Logo} className="logo" alt="Built Intelligence" />
        </Navbar.Brand>
        <Navbar.Toggle
          aria-controls="offcanvasNavbar"
          aria-labelledby="offcanvasNavbarLabel"
          onClick={toggleMenu}
        />
        <Navbar.Offcanvas
          id="offcanvasNavbar"
          placement="end"
          restoreFocus={true}
          show={menuOpen}
          onHide={handleClose}
          backdrop="static"
          scroll={true}
        >
          <Offcanvas.Header closeButton>
            <Offcanvas.Title id={`offcanvasNavbarLabel-expand-xxl`}>
              {platformGetDecodedToken().unique_name}
            </Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <Navbar.Collapse className="justify-content-end">
              {(() => {
                if (platformGetToken() !== null) {
                  return (
                    <Nav defaultActiveKey="/home" className="flex-column">
                      <h4>Overview</h4>
                      <Nav.Link as={Link} to="/home">
                        <Speedometer2 color="white" size={25} />
                        <span className="p-2 h6">FastDraft</span>
                      </Nav.Link>
                      <Nav.Link as={Link} to="/academy">
                        <Book color="white" size={25} />
                        <span className="p-2 h6">Academy</span>
                      </Nav.Link>
                      <Nav.Link as={Link} to="/metrics">
                        <BarChart color="white" size={25} />
                        <span className="p-2 h6">Metrics</span>
                      </Nav.Link>
                      
                      <h4>FastDraft</h4>
                      <Nav.Link as={Link} to="/users">
                        <People color="white" size={25} />
                        <span className="p-2 h6">Sign-Ins / Users</span>
                      </Nav.Link>
                      <Nav.Link as={Link} to="/notices">
                        <BroadcastPin color="white" size={25} />
                        <span className="p-2 h6">Communicated Notices</span>
                      </Nav.Link>
                      
                      <h4>Monthly All Instances</h4>
                      <Nav.Link as={Link} to="/monthly">
                        <GraphUp color="white" size={25} />
                        <span className="p-2 h6">Monthly Overview</span>
                      </Nav.Link>


                      <h4>Reachback</h4>
                      <Nav.Link as={Link} to="/reachback">
                        <People color="white" size={25} />
                        <span className="p-2 h6">Sign-Ins / Users</span>
                      </Nav.Link>

                      <h4>Shopify</h4>
                      <Nav.Link as={Link} to="/shopify">
                        <People color="white" size={25} />
                        <span className="p-2 h6">Sign-Ins / Users</span>
                      </Nav.Link>


                      <h4>Coverage</h4>
                      <Nav.Link as={Link} to="/coverage">
                        <GlobeEuropeAfrica color="white" size={25} />
                        <span className="p-2 h6">Product Coverage</span>
                      </Nav.Link>
                      <h4>Azure</h4>
                      <Nav.Link as={Link} to="/costing">
                        <CurrencyPound color="white" size={25} />
                        <span className="p-2 h6">Costing</span>
                      </Nav.Link>
                      <h4>User</h4>
                      <Nav.Link onClick={() => onLogout()}>
                        <DoorClosed color="white" size={25} />
                        <span className="p-2 h6">Sign Out</span>
                      </Nav.Link>
                    </Nav>
                  );
                }
              })()}
            </Navbar.Collapse>
          </Offcanvas.Body>
          <Container className="d-flex order-2 p-3" fluid>
            <Row className="w-100">
              {(() => {
                // If the page is "monthly" OR "costing" do not display the instance selection dropdown.
                if (
                  window.location.pathname !== "/monthly" &&
                  window.location.pathname !== "/costing"
                ) {
                  return (
                    <Col fluid={"true"} lg={12}>
                      <Dropdown
                        id="range"
                        values={value}
                        onDropDownChange={data.handler}
                      />
                    </Col>
                  );
                }
              })()}
              {(() => {
                // If the page is "users" OR "notices" display the instance selection dropdown.
                if (
                  window.location.pathname === "/users" ||
                  window.location.pathname === "/notices"
                ) {
                  return (
                    <Col fluid={"true"} lg={12}>
                      <Dropdown
                        onDropDownChange={data.handleInstanceChanges}
                        values={instance}
                        id="instance"
                      />
                    </Col>
                  );
                }
              })()}
            </Row>
          </Container>
        </Navbar.Offcanvas>
      </Container>
    </Navbar>
  );
};

export default NavBarMenu;
